export default "__VITE_ASSET__4db1829e__"